<template>
  <div class="header" @mouseleave="navMouseleave" style="font-size: 20px;">
    <div class="content">
      <div class="left">
        <div class="logo" @click="goHome" @mouseenter="navMouseleave">
          <img src="~@/assets/image/header/logo.png" alt="xcontract北京智签科技logo" />
        </div>

        <div class="nav">
          <div
            class="item"
            v-for="(item, index) in navData"
            :key="index"
            @mouseenter="navMouseenter(item.index)"
          >
            <span class="nav_tab" @click="navClick(item.index)"
              >{{ item.name }}
              <template v-if="!item.iconHide">
                <i class="el-icon-arrow-down" v-show="!item.isOpen" />
                <i class="el-icon-arrow-up" v-show="item.isOpen" />
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="tel">
          <!-- <div class="text">17300974710</div>
          <i class="el-icon-phone" /> -->
        </div>
        <div class="login" @click="toLogin">登 录</div>
        <!-- <div class="btn" @click="$router.push('/try'), navMouseleave()">
          免费试用
        </div> -->
      </div>
    </div>
    <div class="navContentBox">
      <div class="navContent" v-show="headerInfoShow">
        <product v-show="navData[0].isOpen" @close="close" />
        <solution v-show="navData[1].isOpen" @close="close" />
        <about_zq v-show="navData[5].isOpen" @close="close" />
        <!-- <help v-show="navData[4].isOpen" @close="close" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import product from "./component/product.vue";
import solution from "./component/solution.vue";
import about_zq from "./component/about_zq.vue";
import help from "./component/help.vue";
export default {
  components: {
    product,
    solution,
    about_zq,
    help,
  },
  data() {
    return {
      navData: [
        { name: "专业产品", index: 1, isOpen: false },
        { name: "解决方案", index: 2, isOpen: false },
        { name: "区块链浏览器", index: 3, iconHide: true },
        { name: "区块链合同验证", index: 5, iconHide: true },
        { name: "新闻速递", index: 6, iconHide: true },
        { name: "关于智签", index: 4, isOpen: false },
        // { name: "支持帮助", index: 5, isOpen: false },
      ],
      headerInfoShow: false,
    };
  },

  created() {},

  methods: {
    // 移入nav
    navMouseenter(index) {
      console.log(index);
      this.navData.forEach((ele) => (ele.isOpen = false));
      if (index == 3||index == 5||index == 6) {
        this.headerInfoShow = false;
      } else {
        // this.navData[index].isOpen = true;
        console.log(this.navData.find(ele=>ele.index==index));
        this.navData.find(ele=>ele.index==index).isOpen = true
        this.headerInfoShow = true;
      }
    },
    // 移出nav
    navMouseleave(index) {
      this.navData.forEach((ele) => (ele.isOpen = false));
      this.headerInfoShow = false;
    },
    navClick(index) {
      if (index == 3) {
        // window.open("https://www.legalxchain.com/cn/blockChain");

        this.$router.push("/blockChain");
      }
      if(index==5){
        this.$router.push("/verification/validate");
      }
      if (index === 6) {
        this.$router.push("/news");
      }
    },
    close() {
      this.headerInfoShow = false;
    },
    goHome() {
      this.$router.push("/home");
    },
    toLogin() {
      this.$router.push("/verification/login");
      this.navMouseleave();
    },
  },
};
</script>

<style scoped lang='scss'>
.header {
  width: 100%;
  height: 64px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  z-index: 9999;
  .content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .left {
      height: 100%;

      display: flex;
      align-items: center;
      .logo {
        cursor: pointer;
        img {
          width: 120px;
          height: 39px;
        }
      }
      .nav {
        margin-left: 64px;
        height: 100%;
        display: flex;
        .item {
          margin-right: 32px;
          cursor: pointer;
          height: 100%;
          line-height: 64px;
          font-size: 15px;
          &:hover {
            color: $main_color;
            cursor: pointer;
          }
        }
        // .item:hover {
        //   color: $main_color;
        // }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .tel {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 32px;
        i {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          text-align: center;
          line-height: 16px;
          background-color: $main_color;
          color: #ffffff;
          font-size: 12px;
        }
        .text {
          font-size: 15px;
          margin-right: 6px;
          color: #000000;
          font-weight: 700;
        }
      }
      .login {
        width: 99px;
        font-size: 16px;
        text-align: center;
        margin: 0 8px 0 0;
        color: #ffffff;
        font-size: 16px;
        cursor: pointer;
        height: 100%;
        line-height: 64px;
        background: #B62229;
        // &:hover {
        //   color: #a90020;
        // }
      }
      .btn {
        width: 99px;
        height: 64px;
        background-color: $main_color;
        line-height: 64px;
        text-align: center;
        font-size: 15px;
        color: #ffffff;
        margin-left: 24px;
        cursor: pointer;
      }
    }
  }
  .navContentBox {
    // background-color: lawngreen;
    width: 100%;
    margin: 0 auto;

    .navContent {
      animation: mymove 0.3s;
      -webkit-animation: mymove 0.3s;
      // transition: all 0.5s;
      // width: 1200px;
      // background-color: pink;
      // margin: 0 auto;
    }
    .navContentLeave {
      animation: mymoveleave 0.3s;
      -webkit-animation: mymoveleave 0.3s;
    }
  }
}
@keyframes mymove {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
